// extracted by mini-css-extract-plugin
module.exports = {"tosContainer":"TOS_tosContainer__r7U34","padded":"TOS_padded__1uafb","tosTitle":"TOS_tosTitle__2HFmx","tosMainTitle":"TOS_tosMainTitle__8opD7"};